import labels from '../../contexts/CruiseSearchContext/labels.json';

export const PROMO_COUNTDOWN = 'promo-countdown';
export const PROMO_ID = 'promo';

export const MAX_COUNTDOWN_HOURS = 72;

export const MAX_PERK_LENGTH = 75;

export const MAX_PERKS_AMOUNT = 3;

export const PERK_TYPES = {
  boolean: 'BooleanPerk',
  dynamicPrice: 'DynamicPricePerk',
  percentOff: 'PercentOffPerk',
  price: 'PricePerk',
};

export const RESOURCE_KEY_PREFIX = 'promotionPerk';

export const DEFAULT_VALUE = 'Any';

export const TEST_DATA = {
  promo: {
    countdownEnabled: true,
    //endDate: add(new Date(), { days: 3, hours: 6, minutes: 12 }),
    endDate: '2022-04-25T03:34:20.763Z',
    perks: [
      {
        name: 'percentOff',
        __typename: 'PercentOffPerk',
        target: 'bogo',
        percent: 50,
      },
      {
        name: 'kidsSailFree',
        qualifier: null,
        __typename: 'BooleanPerk',
      },
      {
        name: 'instantSavings',
        qualifier: 'test',
        price: {
          currency: { code: 'USD', __typename: 'Currency' },
          value: 550,
          __typename: 'Price',
        },
        __typename: 'PricePerk',
      },
      {
        name: 'dynamicPrice',
        search: '',
        defaultPrice: {
          currency: { name: 'USD', symbol: '$', __typename: 'Currency' },
          value: 199,
          __typename: 'Price',
        },
        __typename: 'DynamicPricePerk',
      },
      {
        __typename: 'BooleanPerk',
        name: 'complementaryStateroom',
        description: ['[USA] Complimentary Stateroom including'],
        qualifier: 'rooms for two',
      },
    ],
  },
  locale: {
    country: 'USA',
    currency: 'USD',
    language: 'en',
    market: 'usa',
    office: 'MIA',
  },
  labels,
};
